<template>
  <div class="listo">
    <div class="header-container">
      <header-bar
        :title="title"
        :back-link="backLink"
      />
    </div>
    <item-list
      v-show="loadedItems"
      :items="items"
      @item-clicked="handleClick"
    />
  </div>
</template>

<script>

export default {
    name: 'RecipeList',
    props: {
      title: {
        type: String,
        default: ''
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            loadedItems: false
        }
    },
    computed: {
        items() {
            return this.loadedItems ? this.$store.state.items.recipe : []
        }
    },
    beforeMount() {
        this.$store.dispatch('refreshItems', 'recipe').then(() => {
            this.loadedItems = true
        })
    },
    methods: {
      handleClick(item) {
        this.$router.push({name: 'burle-marx-live-sitio-recipe', params: { recipe: item.friendly } })
      }
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    background: black;
}
</style>